// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1gVNO","productName":"Table_productName__2l6RV"};